export type RegionPathIdsByRegionId = Record<number, number[]>;

export const buildRegionPathIds = (
  path: Array<{
    id: number;
  }>,
): number[] => {
  const pathIds: number[] = [];
  const seenIds = new Set<number>();

  path.forEach((region) => {
    if (!seenIds.has(region.id)) {
      pathIds.push(region.id);
      seenIds.add(region.id);
    }
  });

  return pathIds;
};

export const getUncachedRegionIds = (
  regionIds: Array<number | null | undefined>,
  regionPathIdsByRegionId: RegionPathIdsByRegionId,
): number[] =>
  Array.from(
    new Set(
      regionIds.filter(
        (regionId): regionId is number =>
          regionId != null && regionPathIdsByRegionId[regionId] === undefined,
      ),
    ),
  );

export const matchesSelectedRegions = (
  regionId: number | null | undefined,
  selectedRegionIds: number[],
  regionPathIdsByRegionId: RegionPathIdsByRegionId,
): boolean => {
  if (selectedRegionIds.length === 0) {
    return true;
  }

  if (regionId == null) {
    return false;
  }

  const regionPathIds = regionPathIdsByRegionId[regionId];
  if (!regionPathIds || regionPathIds.length === 0) {
    return selectedRegionIds.includes(regionId);
  }

  return selectedRegionIds.some((selectedRegionId) =>
    regionPathIds.includes(selectedRegionId),
  );
};
